const amendmentResources = ({
  1: 'Governo Federal',
  2: 'Governo Estadual',
  3: 'Pedido de outro parlamentar',
  4: 'Solicitação para Deputado Estadual, Federal',
});

const amendmentResourcesEnum = {
  GOVERNO_FEDERAL: 1,
  GOVERNO_ESTADUAL: 2,
  PEDIDO_OUTRO_PARLAMENTAR: 3,
  SOLICITACAO_PARA_DEPUTADO: 4,
};

export { amendmentResources, amendmentResourcesEnum };
